import React, {useEffect, useState} from 'react'
import AddUser from '../components/Profile/AddUser'
import ChangePage from '../components/Profile/ChangePage'
import "../style/Profile.css"
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import authService from "../components/api-authorization/AuthorizeService";

const Profile = () => {
    const [token, setToken] = useState('')
    const [role, setRole] = useState()
    const [userName, setUserName] = useState('')

    useEffect(async () => {
        const [user] = await Promise.all([authService.getUser()])
        setUserName(user.name)
        const token_resp = await authService.getAccessToken()
        setToken(token_resp)
    }, [])

    useEffect(async () => {
        if (token !== '') {
            fetch('api/Validator', {
                method: 'POST',
                headers: !token ? {} : {
                    'Authorization': `Bearer ${token}`,
                },
            })
        }
    }, [token])

    useEffect(async () => {
        if (token !== '') {
            const user_response = await fetch('api/checkRole?role=admin', {
                headers: !token ? {} : {'Authorization': `Bearer ${token}`}
            })
            const user_role = await user_response.json()
            setRole(((user_role.info === 'false') ? 'user' : 'admin'))
        }
    }, [token])


    return (
        <div id='profile-page'>
            <div className='profile-page-label'>Личный кабинет</div>
            <div className='user-name'>{userName}</div>
            {role === 'admin' ?
                <Tabs
                    defaultActiveKey='changeUser'>
                    <Tab title='Администратор' eventKey='changeUser'>
                        <ChangePage key={token} token={token}/>
                    </Tab>
                    <Tab title='Редактор пользователей' eventKey='addUser'>
                        <AddUser key={token} token={token}/>
                    </Tab>
                </Tabs> : <ChangePage key={token} token={token}/>}
        </div>
    );
};

export default Profile;